import { isAxiosError } from 'axios'

export const OCR_RESULT_PENDING_MESSAGE =
  'Extraction JSON is available after the OCR job finishes. Page metadata above is live.'

export function isOcrResultPending(error: unknown): boolean {
  return isAxiosError(error) && error.response?.status === 404
}
